<template>
  <!-- 五节课 -->
  <div class="fiveLessons">
    <!-- <header>
      <el-date-picker v-model="time" type="date" placeholder="选择日期" clearable>
      </el-date-picker><el-button type="primary" style="margin-left: 20px;">搜索</el-button>
    </header> -->
    <div class="pending">
      <p><i class="el-icon-document" style="margin-right:5px;color: #0e99db;"></i>代办事项</p>
      <div class="pending_bottom">
        <!-- 请假提醒 -->
        <!-- <div class="pending_item leave" @click="leave">
          <p style="color: #fff;">请假提醒</p>
          <p style="color: #fff;">4</p>
        </div> -->
        <!-- 欠、续费提醒 -->
        <!-- <div class="pending_item renew" @click="renew">
          <p style="color: #fff;">欠、续费提醒</p>
          <p style="color: #fff;">4</p>
        </div> -->
        <!-- 教师课后反馈提醒 -->
        <div class="pending_item afterClass" @click="afterClass"
          :style="num == 4 ? 'box-shadow:5px 5px 5px  #ff6d88;' : ''">
          <p style="color: #fff;">教师课后反馈提醒</p>
          <p style="color: #fff;">{{ feedBackNum }}</p>
        </div>
        <!-- 规划师沟通提醒 -->
        <div class="pending_item communication" @click="communication"
          :style="num == 3 ? 'box-shadow:5px 5px 5px #649a5d;' : ''">
          <p style="color: #fff;">规划师沟通提醒</p>
          <!-- <p style="color: #fff;">4</p> -->
        </div>
        <!-- 首次课计划提醒 -->
        <div class="pending_item first" @click="first" :style="num == 5 ? 'box-shadow:5px 5px 5px #da8caa;' : ''">
          <p style="color: #fff;">首次课计划提醒</p>
          <!-- <p style="color: #fff;">4</p> -->
        </div>
        <!-- 家长课堂提醒 -->
        <!-- <div class="pending_item classroom" @click="classroom">
          <p style="color: #fff;">家长课堂提醒</p>
          <p style="color: #fff;">4</p>
        </div> -->
        <!-- 五次课计划提醒 -->
        <div class="pending_item issue" @click="issue" :style="num == 7 ? 'box-shadow:5px 5px 5px #f4ae5c;' : ''">
          <p style="color: #fff;">五次课计划提醒</p>
          <!-- <p style="color: #fff;">4</p> -->
        </div>
      </div>
    </div>
    <!-- 请假提醒弹窗 -->
    <!-- <div class="popup" style="background: #fff; " v-if="num == 1">
      <p class="popup_top" style="text-align: left;"><i class="el-icon-warning"
          style="color: #0e99db; margin-right: 5px;"></i><span style="margin-right: 100px;">请假提醒</span>
      </p>
      <el-form class="demo-form-inline">
        <el-form-item label="学生姓名:" label-width="100px">
          <el-input placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button type="primary">清除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">添加请假记录</el-button>
          <el-button type="primary">请假历史记录</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" stripe style="width: 99%; margin:20px auto; " border :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center'
      }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="date" label="日期">
        </el-table-column>
        <el-table-column prop="name" label="学生姓名">
        </el-table-column>
        <el-table-column prop="address" label="教师">
        </el-table-column>
        <el-table-column prop="address" label="课程名称">
        </el-table-column>
        <el-table-column prop="address" label="上课时间">
        </el-table-column>
        <el-table-column prop="address" label="是否请假">
        </el-table-column>
        <el-table-column prop="address" label="是否沟通">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="prev, pager, next,sizes, jumper" :total="total">
      </el-pagination>
    </div> -->
    <!-- 欠、续费提醒 -->
    <!-- <div class="popup" style="background: #fff;" v-if="num == 2">
      <p class="popup_top" style="text-align: left; margin-top: 15px;"><i class="el-icon-warning"
          style="color: #0e99db; margin-right: 5px;"></i><span style="margin-right: 100px;">欠、续费提醒</span>
      </p>
      <el-form class="demo-form-inline">
        <el-form-item label="学生姓名:" label-width="100px">
          <el-input placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button type="primary">清除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">欠、学费历史记录</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" stripe style="width: 99%; margin:20px auto; " border :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center'
      }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="date" label="日期">
        </el-table-column>
        <el-table-column prop="name" label="学生姓名">
        </el-table-column>
        <el-table-column prop="address" label="购买总课次">
        </el-table-column>
        <el-table-column prop="address" label="已上课次">
        </el-table-column>
        <el-table-column prop="address" label="剩余课次">
        </el-table-column>
        <el-table-column prop="address" label="相关销售">
        </el-table-column>
        <el-table-column prop="address" label="提醒情况">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row">
              <el-radio :label="1">备选项</el-radio>
              <el-radio :label="2">备选项</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="prev, pager, next,sizes, jumper" :total="total">
      </el-pagination>
    </div> -->
    <!-- 规划师沟通提醒 -->
    <communicateVue v-show="num == 3"></communicateVue>
    <!-- 教师课后反馈提醒 -->
    <feedBack v-show="num == 4"></feedBack>
    <!-- 首次课计划提醒 -->
    <fistClass v-show="num == 5"></fistClass>
    <!-- 家长课堂提醒 -->
    <!-- <div class="popup" style="background: #fff;" v-if="num == 6">
      <p class="popup_top" style="text-align: left; margin-top: 15px;"><i class="el-icon-warning"
          style="color: #0e99db; margin-right: 5px;"></i><span style="margin-right: 20px;">家长课堂提醒</span></p>
      <el-form class="demo-form-inline">
        <el-form-item label="上课日期:" label-width="80px">
          <el-date-picker type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="课程名称:" label-width="100px">
          <el-input placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="相关销售:" label-width="100px">
          <el-input placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button type="primary">添加课程</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">家长课堂历史记录</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" stripe style="width: 99%; margin:20px auto; " border :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center'
      }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="name" label="学生姓名">
        </el-table-column>
        <el-table-column prop="date" label="首次课日期">
        </el-table-column>
        <el-table-column prop="address" label="首次课教师">
        </el-table-column>
        <el-table-column prop="address" label="首次课计划教师完成情况">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row">
              <el-radio :label="1">备选项</el-radio>
              <el-radio :label="2">备选项</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="上课时间">
        </el-table-column>
        <el-table-column prop="address" label="相关销售">
        </el-table-column>
        <el-table-column prop="address" label="首次课成功情况">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row">
              <el-radio :label="1">备选项</el-radio>
              <el-radio :label="2">备选项</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="prev, pager, next,sizes, jumper" :total="total">
      </el-pagination>
    </div> -->
    <!-- 五次课计划提醒 -->
    <fiveClass v-show="num == 7"></fiveClass>
  </div>
</template>

<script>
import communicateVue from '../afterSales/communicate.vue'
import fistClass from '../afterSales/fistClass.vue';
import fiveClass from '../afterSales/fiveClass.vue';
import feedBack from '../afterSales/feedBack.vue';
import { getNum } from "@/api/feedBackApi"
export default {
  components: {
    communicateVue, fistClass, feedBack, fiveClass
  },
  data () {
    return {
      feedBackNum: 0,
      num: 4,
      total: 0,
      tableData: [

      ],//表格绑定的数组
      time: ''//头部搜索框绑定的时间
    }
  },
  created () {
    this.getTotal()
    setInterval(() => {
      this.getTotal()
    }, 60000)
  },
  methods: {
    //获取教师课后反馈提醒数据
    getTotal () {
      getNum().then(res => {
        this.feedBackNum = res.data
      })
    },
    //分页
    handleSizeChange () {

    },
    //进入某一页
    handleCurrentChange () {

    },
    //请假提醒
    leave () {
      this.num = 1
    },
    //欠、续费提醒
    renew () {
      this.num = 2
    },
    //规划师沟通提醒
    communication () {
      this.num = 3
    },
    //教师课后反馈提醒
    afterClass () {
      this.num = 4
    },
    //首次课计划提醒
    first () {
      this.num = 5
    },
    //家长课堂提醒
    classroom () {
      this.num = 6
    },
    //五次课计划提醒
    issue () {
      this.num = 7
    }
  }
}

</script>

<style scoped>
header {
  text-align: left;
}

.pending {
  text-align: left;
}

.pending p {
  font-size: 14px;
}

.pending_bottom {
  width: 100%;
  height: 140px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
}

.pending_item {
  width: 170px;
  height: 100px;
  border-radius: 10px;
}

.pending_item p {
  margin-top: 20px;
  margin-left: 25px;
}

.leave {
  background: linear-gradient(to right, #028bcf, #80d0f6);
}

.renew {
  background: linear-gradient(to right, #fdbe29, #fecf64);
}

.communication {
  background: linear-gradient(to right, #5d9656, #aac8a6);
}

.afterClass {
  background: linear-gradient(to right, #ff698a, #fe9f74);
}

.first {
  background: linear-gradient(to right, #d87ea3, #e3c5c6);
}

.classroom {
  background: linear-gradient(to right, #1da8aa, #94e0dd);
}

.issue {
  background: linear-gradient(to right, #f4ab56, #f6cd9e);
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.demo-form-inline .el-form-item {
  margin-right: 30px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .fiveLessons {
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.fiveLessons {
    width: 70% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/manager/components/FiveLessons.vue